import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watch } from 'vue'
import { usePageStore } from '@/store/page'
import { useSessionStore } from '@/store/sessions'
import LoadingPage from '@/components/LoadingPage.vue'
import ToastAlert from '@/components/ToastAlert.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const pageStore = usePageStore()
const sessionStore = useSessionStore()

watch(() => pageStore.openMenu, (value) => {
  if (value) {
    document.body.classList.remove('sidebar-show')
    document.body.classList.add('sidebar-hide')
  } else {
    document.body.classList.add('sidebar-show')
    document.body.classList.remove('sidebar-hide')
  }
})

onMounted(() => {
  sessionStore.loadSession()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_unref(pageStore).pageLoading)
      ? (_openBlock(), _createBlock(LoadingPage, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(ToastAlert),
    (_ctx.$route.meta.layout)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$route.meta.layout || 'div'), { key: 1 }))
      : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
  ]))
}
}

})